<template>
  <div
    class="modal-task start-task-wrapper"
    :class="{ 'workflow-model-scroll': task.props.trigger == 'formTrigger' }"
  >
    <div class="modal-backdrop"></div>
    <div class="modal task" :class="{ fullscreen: isFullScreen }">
      <div class="modal-header-actions">
        <div
          class="fullscreen-icon"
          :class="{ disabled: !isUserHasAccess }"
          v-b-tooltip.hover.top
          title="Vollbild"
          @click="isUserHasAccess && toggleFormFullScreen()"
        >
          <i v-if="!isFullScreen" class="fas fa-expand"></i>
          <i v-else class="fas fa-compress"></i>
        </div>
        <div class="modal-close" @click="close"></div>
      </div>
      <div v-if="!loading" class="content">
        <div class="tab tab-form">
          <div class="header">
            <div class="tools">
              <div
                v-if="isVueBasedFormBuilder"
                class="round-button item magic-comment"
                @click="toggleAskAiLogicModal(true)"
                v-b-tooltip.hover.top
                title="Magic Comment"
              >
                <div>
                  <img src="../../assets/img/magin-comment-icon.svg" alt="" />
                </div>
              </div>
              <div
                v-if="!isVueBasedFormBuilder"
                class="round-button item"
                @click="showAskAiUiModal()"
                v-b-tooltip.hover.top
                title="Mit KI formatieren"
              >
                <i class="fa fa-magic"></i>
              </div>
              <div
                class="round-button item preview"
                :disabled="!isUserHasAccess"
                v-b-tooltip.hover.top
                title="Vorschau"
                @click="toggleFormPreview(true)"
              >
                <div>
                  <img
                    src="../../assets/img/work-flow-icons/preview-without-border.svg"
                    alt=""
                  />
                </div>
              </div>
              <div
                v-if="!isVueBasedFormBuilder"
                class="round-button item daten-bank-schema"
                :disabled="!isUserHasAccess"
                @click="toggleDatabaseSchemaModal(true)"
                v-b-tooltip.hover.top
                title="Datenbankschema"
              >
                <img src="../../assets/img/database-schema-copy.svg" alt="" />
              </div>
              <div
                v-if="isVueBasedFormBuilder || task?.name == 'Start'"
                class="round-button item"
                :disabled="!isUserHasAccess"
                @click="showFlowReferenceModal()"
                v-b-tooltip.hover.bottom
                title="Einstellungen"
              >
                <i class="fa fa-cog"></i>
              </div>
              <div
                v-if="isVueBasedFormBuilder || task?.name == 'Start'"
                class="round-button item save-workflow"
                :class="{
                  disabled: !isUserHasAccess || isSaveFlowLoading,
                }"
                @click="saveFlow()"
                v-b-tooltip.hover.bottom
                title="Speichern"
              >
                <b-spinner
                  v-if="isSaveFlowLoading"
                  small
                  label="Spinning"
                ></b-spinner>
                <i v-else class="fa fa-save"></i>
              </div>
              <div
                class="round-button item options"
                :disabled="!isUserHasAccess"
                v-b-tooltip.hover.right
                title="weitere Funktionen"
              >
                <generalDropdown
                  :disabled="!isUserHasAccess"
                  className="filter-dropdown"
                  :isCaretVisible="false"
                >
                  <template v-slot:selectFilter>
                    <span class="line-clamp">
                      <i class="fas fa-ellipsis-h"></i>
                    </span>
                  </template>
                  <template v-slot:optionData>
                    <b-dropdown-item
                      v-for="option in getDropDownItems"
                      :key="option.label"
                    >
                      <div
                        class="extra-options-wrapper"
                        @click="option.clickTrigger"
                      >
                        <i :class="option.icon"></i>
                        <span>{{ option.label }}</span>
                      </div>
                    </b-dropdown-item>
                  </template>
                </generalDropdown>
              </div>
              <div
                v-if="false"
                class="round-button item"
                @click="showFlowAuthModal()"
              >
                <i class="far fa-user"></i>
              </div>
            </div>
          </div>
          <div class="form-container">
            <form
              :class="{ 'full-width': settings.fullWidth }"
              v-if="!isVueBasedFormBuilder"
              class="initial-form"
            >
              <div class="form-header">
                <!-- <input
                  class="title"
                  v-model="task.props.formTrigger.title"
                  contenteditable="true"
                  placeholder="Title eingeben..."
                />
                <input
                  v-show="false"
                  class="description"
                  v-model="task.props.formTrigger.description"
                  contenteditable="true"
                  placeholder="Beschreibung eingeben..."
                /> -->
              </div>
              <FormBuilderV2
                v-if="!isVueBasedFormBuilder"
                :key="`fb2-${formBuilderRenderKey}`"
                :isAskAiUiModalVisible="isAskAiUiModalVisible"
                :flowRunnerEndpoint="flowRunnerEndpoint"
                class="start-form-builder"
                :elements="elements"
                :structure="structure"
                :isFullWidth="settings.fullWidth"
                :formulaVersion="getformulaVersion"
                :isHtmlElementVisible="settings.isHtmlElementVisible"
                :isEditable="true"
                :isContentEditable="true"
                :isUserHasAccess="isUserHasAccess"
                :process="process"
                :elementInputs="task.input"
                :elementsToHide="getElementsToHide"
                :task="task"
                @saveElements="saveElements"
                @saveStructure="saveStructure"
                @addUiInUiElement="addUiInUiElement"
                @showAskAiUiModal="showAskAiUiModal"
                @toggleAiDropdown="toggleAiDropdown"
              />
            </form>
            <div
              :style="{ maxWidth: getFormMaxWidth }"
              class="form-builder-wrapper"
              @mouseover="
                isAskAiModalVisible &&
                  !selectedElementId &&
                  handleFormHover($event)
              "
              @mouseleave="
                isAskAiModalVisible &&
                  !selectedElementId &&
                  handleFormMouseLeave($event)
              "
              @click.capture="
                isAskAiModalVisible && handleFormElementsClick($event)
              "
              v-if="isVueBasedFormBuilder"
            >
              <FormBuilder
                ref="formBuilderRef"
                :key="`fb3-${formBuilderRenderKey}`"
                :isAskAiModalVisible="isAskAiModalVisible"
                :flowRunnerEndpoint="flowRunnerEndpoint"
                class="start-form-builder"
                :elements="elements"
                :brandedStyle="this.process.style"
                :structure="structure"
                :isFullWidth="settings.fullWidth"
                :isHtmlElementVisible="settings.isHtmlElementVisible"
                :isEditable="true"
                :isContentEditable="true"
                :isUserHasAccess="isUserHasAccess"
                :elementInputs="task.input"
                :elementsToHide="getElementsToHide"
                :taskName="task.name"
                :settings="task?.props?.settings"
                :currentScreen="currentScreen"
                :tabStructure="task?.props?.structure"
                :flowSettings="settings"
                @saveElements="saveElements"
                @saveStructure="saveStructure"
                @addUiInUiElement="addUiInUiElement"
                @showAskAiUiModal="showAskAiUiModal"
                @toggleAiDropdown="toggleAiDropdown"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="loading-spinner">
        <LoadingSpinner :loadingCaption="'wird gespeichert...'" />
      </div>
      <flowAuthModal
        @close="hideFlowAuthModal()"
        @save="saveFlowSettings()"
        :flowSettings="this.settings"
        v-if="isFlowAuthModalVisible"
      ></flowAuthModal>
      <flowReferenceModal
        @close="hideFlowReferenceModal()"
        @save="saveFlowSettings()"
        @setShowResultInForm="$emit('setShowResultInForm', $event)"
        :flowSettings="this.settings"
        :task="this.task"
        :process="this.process"
        :isAdmin="this.isAdmin"
        :showDatabaseMissing="showDatabaseMissing"
        :isUserHasAccess="isUserHasAccess"
        :databases="getCustomDatabases"
        :isTableIdArray="isTableIdArray"
        :getSelectedDbList="getSelectedDbList"
        :currentScreen="currentScreen"
        @onChangeCustomSpacingScreen="onChangeCustomSpacingScreen"
        v-if="isFlowReferenceModalVisible && task?.name == 'Start'"
      ></flowReferenceModal>
      <FormSettingModal
        v-if="isFlowReferenceModalVisible && task?.name == 'Form'"
        :task="task"
        :process="process"
        :currentScreen="currentScreen"
        :isUserHasAccess="isUserHasAccess"
        @close="hideFlowReferenceModal()"
        @onChangeCustomSpacingScreen="onChangeCustomSpacingScreen"
      />
      <askAiUiModal
        :flowRunnerEndpoint="flowRunnerEndpoint"
        v-if="isAskAiUiModalVisible"
        @close="hideAskAiUiModal()"
        @addUiInUiElement="addUiInUiElement"
        :elements="elements"
        @removeAiCss="removeAiCss"
        :isAiDropdownVisible="isAiDropdownVisible"
      >
      </askAiUiModal>
      <AskAImodal
        v-if="isAskAiModalVisible"
        :processId="process.id"
        :task="task"
        :elements="elements"
        :isLoading="isAskAiLoading"
        :flowRunnerEndpoint="flowRunnerEndpoint"
        @close="toggleAskAiLogicModal(false)"
        @showToaster="showToaster"
        @toggleloading="toggleAskAiLoading"
      />
      <FloatingAskAiDropdown
        v-if="selectedElementId"
        :processId="process.id"
        :task="task"
        :elements="elements"
        :selectedId="selectedElementId"
        :flowRunnerEndpoint="flowRunnerEndpoint"
        @onClose="onCloseFloatingDropdown"
      />

      <JsonImportFormModal
        v-if="isImportFormModalVisible"
        @onFileImport="onFileImport"
        @close="isImportFormModalVisible = false"
      />
      <ImportFormConfirmModal
        v-if="isImportConfirmModalVisible"
        @close="closeImportConfirmModal"
        @replace="confirmImportReplace"
        @merge="confirmImportMerge"
      />
      <DatabaseSchemaSelect
        v-if="copyDatabaseSchemaIntoWorkflow.showDatabaseSchemaModal"
        @close="toggleDatabaseSchemaModal"
        @save="addSchemaIntoWorkflow"
      >
      </DatabaseSchemaSelect>
      <!-- AI Hover Label -->
      <span class="ai-hover-label" ref="aiHoverLabelRef"></span>
      <!-- preivew wrapper -->
      <div class="preview-wrapper" v-if="isFormPreview || isPreviewLoading">
        <div class="loading-container" v-if="isPreviewLoading">
          <LoadingSpinner
            loadingCaption="Vorschau wird geladen..."
            v-show="isPreviewLoading"
          />
        </div>
        <div
          v-if="isFormPreview && (formPreviewBlobURL || isVueBasedFormBuilder)"
          :class="{ hide: isPreviewLoading }"
        >
          <PagePreviewModal
            v-if="isVueBasedFormBuilder"
            @onClose="toggleFormPreview"
            @onPreviewLoad="onPreviewLoad"
            :extraStyles="getPreviewFormStyles"
            :formBuilderProps="{
              elements: elements,
              settings: task.props?.settings,
              processID: process.id,
              isPreview: true,
              version: null,
              brandedStyle: process.style,
              tabStructure: task?.props?.structure,
            }"
          >
          </PagePreviewModal>
          <PagePreviewModal
            v-else
            @onClose="toggleFormPreview"
            @onPreviewLoad="onPreviewLoad"
            :url="formPreviewBlobURL"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import flowReferenceModal from '../modals/flowReferenceModal.vue';
import FormSettingModal from '../FormBuilder/FormSettingModal.vue';
import LoadingSpinner from '../widgets/LoadingSpinner.vue';
import flowAuthModal from '../modals/flowAuthModal.vue';
import FormBuilderV2 from '../widgets/FormBuilderV2.vue';
import FormBuilder from '../FormBuilder/FormBuilderV3.vue';
import askAiUiModal from '../modals/askAiUiModal.vue';
import { generateFlowHtml } from '../../services/workflow.service';
import { mapGetters } from 'vuex';
import {
  getDataApiVersion,
  getIsVueBasedFormBuilder,
  getScreenBreakPoints,
  getUniqueID,
  showToaster,
} from '@/utils/helpers';
import GeneralDropdown from '../core/general-dropdown.vue';
import DatabaseSchemaSelect from '../modals/databaseSchemaSelect.vue';

import PagePreviewModal from '@/components/modals/PagePreviewModal.vue';
import {
  getFormElements,
  getFormStructure,
  findElementWithNoChildsFromTab,
  openParentToggleListById,
  getFormPromptSuggestions,
} from '@/utils/helpers/FormBuilderHelper.js';

import AskAImodal from '@/components/FormBuilder/AskAI/AskAIModal.vue';
import JsonImportFormModal from '@/components/modals/JsonImportFormModal.vue';
import ImportFormConfirmModal from '@/components/modals/ImportFormConfirmModal.vue';
import { exportFormSchema } from '@/utils/helpers/formSchemaExportHelper.js';
import {
  pageChartTypes,
  getPagePropChartKey,
} from '@/utils/helpers/PageBuilderHelper.js';

export default {
  name: 'Start',
  data() {
    return {
      title: 'Title',
      description: 'eine Beschreibung ist',
      curlTemplate:
        'curl -X POST \\ -H "Accept: */*" \\ -H "Authorization: Bearer {{bearerToken}}" \\ -H "Connection: keep-alive" \\ -H "Content-Type: application/x-www-form-urlencoded" \\ -d "{{dataString}}" \\ {{url}}',
      selectedElement: {
        label: 'Text Bereich',
        type: '',
        value: '',
        attributes: {
          required: false,
        },
      },
      isFlowReferenceModalVisible: false,
      isAskAiUiModalVisible: false,
      isFlowAuthModalVisible: false,
      isPropsModalVisible: false,
      activeDropZone: null,
      loading: false,
      isAddElementVisible: false,
      databases: [],
      aiDropdownId: [],
      copyDatabaseSchemaIntoWorkflow: {
        showDatabaseSchemaModal: false,
        selectedSchema: null,
      },
      isPreviewLoading: false,
      isFormPreview: false,
      formPreviewBlobURL: '',
      currentScreen: 'desktop',
      isAskAiModalVisible: false, // for new form builder v3

      selectedElementId: null,
      aiModalHoverElId: null,

      isAskAiLoading: false,
      isFullScreen: false,
      isImportFormModalVisible: false,
      isImportConfirmModalVisible: false,
      pendingImportFile: null,
      isSaveFlowLoading: false,
      formBuilderRenderKey: 0,
    };
  },
  props: {
    flowRunnerEndpoint: {
      type: String,
    },
    flowId: Number,
    process: Object,
    settings: Object,
    task: Object,
    databaseSchema: [Array, Promise, Function],
    showDatabaseMissing: Boolean,
    isTableIdArray: Boolean,
    isUserHasAccess: { type: Boolean, default: true },
    isFileKeySelectModalVisible: { type: Boolean, default: false },
  },
  methods: {
    close: async function () {
      if (
        this.process?.version >= 3 &&
        this.task?.props?.structure?.tabs?.length > 1
      ) {
        if (this.isTabEmpty()) {
          this.showToaster(
            'Einige Registerkarten sind leer. Bitte fügen Sie Elemente hinzu oder entfernen Sie die leeren Registerkarten',
            'Fehler!',
            'danger'
          );
          return;
        }
      }
      if (this.task.name == 'Start' || this.task.name == 'Form') {
        if (this.process.version == 3) {
          const emptyToggleListElements = this.task.props.elements.filter(
            (el) => el.type === 'togglelist'
          );
          const allHiddenElementIds = this.task.props.elements
            .filter((el) => el.type === 'hidden')
            .map((el) => el.id);
          const emptyToggleItem = findElementWithNoChildsFromTab(
            this.task?.props?.structure.tabs,
            emptyToggleListElements.map((el) => el.id),
            allHiddenElementIds
          );
          const toggleItemDetails = emptyToggleListElements.find(
            (el) => el.id === emptyToggleItem?.id
          );
          if (toggleItemDetails) {
            if (emptyToggleItem.hasChild) {
              const toastMessage = `Schließen nicht möglich. Bitte fügen Sie mindestens ein sichtbares Element zu ${toggleItemDetails?.label} hinzu.`;

              showToaster(this, toastMessage, 'Fehlerhaft !', 'danger');
              if (this.$refs?.formBuilderRef?.tabData) {
                this.$set(
                  this.$refs.formBuilderRef.tabData,
                  'activeTabIndex',
                  emptyToggleItem.tabIndex
                );
              }
              this.$nextTick(() => {
                openParentToggleListById(null, toggleItemDetails.id);
              });
              return;
            }
          }
        }
        this.task.output = [];
        this.putElemetsInOutput().then(() => {
          if (this.task.name == 'Form')
            this.$set(
              this.task,
              'output',
              this.task.output.concat(this.task.input)
            );
          if (this.isFileKeySelectModalVisible) {
            this.loading = false;
          } else {
            this.loading = false;
            ['aiUIStyles', 'ai-generated-form-styles'].forEach((styleId) => {
              const styleElement = document.getElementById(styleId);
              if (styleElement) {
                document.head.removeChild(styleElement);
              }
            });
            this.$emit('close');
          }
        });
      }
      if (this.settings && this.task.name != 'Form') this.addSettingsAsOutput();
    },
    drag: function (event) {
      event.dataTransfer.setData('selectedIdx', event.target.id);
    },
    dragover: function (event) {
      this.activeDropZone = event.target.id;
      event.preventDefault();
    },
    drop: function (event) {
      // Get relevant data from event
      var dropZone = event.target.classList[1];
      var selectedIdx = event.dataTransfer.getData('selectedIdx');
      var targetIdx = event.target.id;
      const elements = getFormElements(this.task, this.isVueBasedFormBuilder);

      var selectedItem = elements[selectedIdx];

      // Handle new cols
      if (dropZone == 'vertical') {
        let tab = this.activeTab;
        let row = targetIdx;
        let path = this.formStructure['tabs'][tab]['rows'][row]['cols'];

        // Update the draged item
        selectedItem.structure.col = path.length;

        // Create new col
        this.$set(path, path.length, { id: path.length });
      } else {
        var selected = elements.splice(selectedIdx, 1)[0];
        elements.splice(targetIdx, 0, selected);
        this.activeDropZone = null;
      }
    },
    putElemetsInOutput: async function () {
      this.loading = true;
      const elements = getFormElements(this.task, this.isVueBasedFormBuilder);
      if (this.process?.version >= 3 && this.settings?.addAuthorizationToken) {
        if (!Array.isArray(this.task.input)) this.$set(this.task, 'input', []);
        const authorizationInput = this.task.input.find(
          (e) => e?.name === 'authorization'
        );
        const authorizationElement = elements.find(
          (e) => e?.name === 'authorization'
        );

        const userName = localStorage.getItem(
          'CognitoIdentityServiceProvider.61nps3sbkg5vcrn4vl5hduqbf4.LastAuthUser'
        );
        const token = localStorage.getItem(
          'CognitoIdentityServiceProvider.61nps3sbkg5vcrn4vl5hduqbf4.' +
            userName +
            '.accessToken'
        );

        if (token) {
          const authorizationValue = 'Bearer ' + token;

          if (!authorizationInput && !authorizationElement) {
            elements.push({
              name: 'authorization',
              label: 'authorization',
              type: 'text',
              value: authorizationValue,
            });
          } else {
            if (authorizationInput) {
              this.$set(authorizationInput, 'value', authorizationValue);
            }
            if (authorizationElement) {
              this.$set(authorizationElement, 'value', authorizationValue);
            }
          }
        }
      }
      await Promise.all(
        elements.map(async (e) => {
          if (!this.getElementSettings(e, 'layoutItem')) {
            let el = {
              name: e.name,
              label: e.label,
              type: e.type,
              value: e.value,
            };
            switch (e.type) {
              case 'html':
              case 'resultwindow':
                break;

              // Transform input of type file to codelos file
              case 'file':
                try {
                  el.value = e.files[0];
                  this.task.output.push(el);
                } catch {
                  console.log('No File found');
                }
                break;

              // Hidden type is always text
              case 'hidden':
                el.type = 'text';
                this.task.output.push(el);
                break;

              // Get model keys from database
              case 'model':
                // TODO: remove timeseries condition if all DB flows updated to loadprofile
                if (this.isLoadProfileOrTimeseries) el.type = el.label;
                else el.type = 'model';
                el.value = await this.getFile(el.value);
                this.task.output.push(el);
                break;
              default:
                this.task.output.push(el);
                break;
            }
          }
        })
      );
    },
    addSettingsAsOutput: function () {
      // replace element if exists
      let indx = this.task.output.indexOf(
        this.task.output.filter((e) => e.isFromSettings)[0]
      );

      let e = {
        label: 'codelosSettings',
        name: 'codelosSettings',
        type: 'text',
        value: null,
        options: [],
        attributes: [],
        isFromSettings: true,
      };

      if (indx != -1) this.$set(this.task.output, indx, e);
      else this.$set(this.task.output, this.task.output.length, e);
    },
    setTrigger: function (Trigger) {
      this.task.props.trigger = Trigger;
    },
    showFlowReferenceModal: function () {
      if (!this.isUserHasAccess) return;
      this.isFlowReferenceModalVisible = true;
    },
    showAskAiUiModal() {
      if (this.isAskAiUiModalVisible) {
        this.isAskAiUiModalVisible = false;
      } else {
        this.isAskAiUiModalVisible = true;
      }
    },
    hideAskAiUiModal() {
      this.isAskAiUiModalVisible = false;
    },
    showFlowAuthModal: function () {
      this.isFlowAuthModalVisible = true;
    },
    hideFlowReferenceModal: function () {
      this.isFlowReferenceModalVisible = false;
    },
    hideFlowAuthModal: function () {
      this.isFlowAuthModalVisible = false;
    },
    saveFlowSettings: function () {
      this.isFlowReferenceModalVisible = false;
      this.isFlowAuthModalVisible = false;
    },
    updatePageNodeValues(pageChildren) {
      pageChildren.forEach((pageNode) => {
        if (pageChartTypes.includes(pageNode.type)) {
          pageNode.value[getPagePropChartKey(pageNode.type)] = {};
        }
        if (pageNode.type == 'col') {
          pageNode.elements.forEach((element) => {
            this.updatePageNodeValues(element.children);
          });
        }
      });
    },
    getFilterProcessData() {
      const process = JSON.parse(JSON.stringify(this.process));
      process.tasks.forEach((task) => {
        if (task.name == 'PageBuilder' && task?.props?.jsonContent?.children) {
          this.updatePageNodeValues(task.props.jsonContent.children);
        }
      });

      return process;
    },
    async saveFlow() {
      if (!this.isUserHasAccess || this.isSaveFlowLoading) return;
      if (!this.process?.name || this.process.name.trim() === '') {
        this.showToaster(
          'Bitte geben Sie den Namen des Workflows ein',
          'Fehler',
          'danger'
        );
        return;
      }
      this.isSaveFlowLoading = true;
      try {
        const res = await this.$store.dispatch('saveFlow', {
          flow: this.getFilterProcessData(),
        });
        if (res && typeof res == 'number') {
          this.showToaster('Gespeichert !', 'Erfolgreich', 'success');
        } else {
          throw new Error(res);
        }
      } catch (error) {
        this.showToaster('Fehler beim Speichern !', 'Fehlerhaft !', 'danger');
      } finally {
        this.isSaveFlowLoading = false;
      }
    },
    async generateHtml(shouldShareStyle = false) {
      const elements = getFormElements(this.task, this.isVueBasedFormBuilder);
      const formData = new FormData();

      if (!this.isVueBasedFormBuilder) {
        const { title } = this.task.props.formTrigger;
        formData.append('title', title);
      }
      formData.append('id', this.flowId);
      formData.append('elements', JSON.stringify(elements));
      formData.append('settings', JSON.stringify(this.settings));
      if (shouldShareStyle && this.process.style)
        formData.append('style', JSON.stringify(this.process.style));
      if (this.settings.apiEndpoint) {
        formData.append('api_endpoint', this.settings.apiEndpoint);
      }
      return await generateFlowHtml(formData, this.getFormBuilderURl);
    },
    copyEmbedScript() {
      if (!this.isUserHasAccess) return;

      const apiEndpoint = this.settings.apiEndpoint
        ? this.settings.apiEndpoint
        : process.env.VUE_APP_FLOW_RUNNER_API;

      let html =
        '<!-- Codelos Inline-Widget Beginn -->\n<div' +
        ` id="codelos-inline-widget-${this.flowId}"` +
        '></div>\n<script' +
        ` id="codelos-inline-script-${this.flowId}" ` +
        'src="' +
        apiEndpoint +
        '/embed-script/' +
        this.flowId +
        '?include_id=true' +
        // ATTENTION: / (slash) in <\/script> end tags must be delimited using \ after each format of the document
        // eslint-disable-next-line no-useless-escape
        '"><\/script>\n<!-- Codelos Inline-Widget Ende -->';
      this.copyToClipboard(html);
      this.showToaster('Kopiert', 'Erfolgreich!', 'success');
    },
    createCURL() {
      if (!this.isUserHasAccess) return;

      let url = this.settings.apiEndpoint
        ? this.settings.apiEndpoint
        : process.env.VUE_APP_FLOW_RUNNER_API;
      url += '/run_flow_by_id';
      url += '?id=' + this.flowId;

      // Prepare cURL
      let cURL = this.curlTemplate
        .replace(
          '{{bearerToken}}',
          this.user.signInUserSession.accessToken.jwtToken
        )
        .replace('{{dataString}}', this.paramString)
        .replace('{{url}}', url);

      this.copyToClipboard(cURL);
      this.showToaster('Kopiert', 'Erfolgreich!', 'success');
    },
    async getFormAsHtmlFile() {
      if (!this.isUserHasAccess) return;
      const response = await this.generateHtml(true);

      if (response && response.status === 200 && response.data) {
        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.process.name + '.html';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    copyToClipboard: function (text) {
      var dummy = document.createElement('textarea');
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    },
    getFile: async function (key) {
      try {
        let url = process.env.VUE_APP_DATA_API;
        let tableName = this.process.tableID;

        if (this.isTableIdArray) {
          if (this.process.tableID.length > 0) {
            tableName = this.process.tableID[0];
          } else {
            tableName = undefined;
            this.setFileKeyModal();
            return;
          }
        }
        // TODO: remove timeseries condition if all flows updated to loadprofile
        if (this.isLoadProfileOrTimeseries) {
          const databaseName = key.split('/');
          if (
            databaseName.length &&
            databaseName[databaseName.length - 1].split('::').length &&
            databaseName[databaseName.length - 1].split('::')[0] === tableName
          ) {
            url +=
              '/files/' +
              encodeURIComponent(key) +
              '?use_pre_signed_s3_url=true';
          } else {
            this.setFileKeyModal();
            return;
          }
        } else {
          url = encodeURI(
            `${process.env.VUE_APP_DATA_API_BASE_URL}/${getDataApiVersion(
              tableName
            )}/user-tables/${tableName}/items/${encodeURIComponent(key)}`
          );
        }

        const myHeaders = new Headers();
        myHeaders.append(
          'Authorization',
          'Bearer ' + this.user.signInUserSession.accessToken.jwtToken
        );

        if (tableName) {
          const response = await fetch(encodeURI(url), {
            method: 'GET',
            headers: myHeaders,
          });

          if (response.status === 401) {
            localStorage.clear();
            this.$router.push({
              name: 'auth',
              params: { message: 'Sitzung abgelaufen' },
            });
            return;
          } else if (response.status === 404 || response.status === 500) {
            this.setFileKeyModal();
            return false;
          }
          const json = await response.json();
          if (this.isLoadProfileOrTimeseries) {
            const res = await fetch(json['presigned-url']);
            if (res.status === 404 || res.status === 500) {
              this.setFileKeyModal();
              return false;
            }
            const loadCurve = await res.json();
            return loadCurve;
          } else {
            return json;
          }
        }
      } catch (error) {
        // Handle the error appropriately here
        if (error instanceof TypeError && error.message === 'Failed to fetch') {
          this.setFileKeyModal();
        }
        console.error('Error fetching file:', error);
      }
    },
    setFileKeyModal() {
      this.$emit('showFileKeySelectModal');
    },
    saveElements: function (elements) {
      if (this.isVueBasedFormBuilder) {
        this.task.props.elements = elements;
      } else {
        this.task.props.formTrigger.elements = elements;
      }
    },
    saveStructure: function (structure) {
      if (this.isVueBasedFormBuilder) {
        this.task.props.structure = structure;
      } else {
        this.task.props.formTrigger.structure = structure;
      }
    },
    isElementHasSettings(element) {
      return element.hasOwnProperty('settings');
    },
    getElementSettings(element, key) {
      if (this.isElementHasSettings(element)) {
        return element.settings.hasOwnProperty(key)
          ? element.settings[key]
          : null;
      } else {
        return element.hasOwnProperty(key) ? element[key] : null;
      }
    },

    addUiInUiElement(uiCssString, isAppend = false) {
      const elements = getFormElements(this.task, this.isVueBasedFormBuilder);
      const uiElementIndex = elements.findIndex(
        (el) => el.name === 'automatedaicss'
      );
      if (uiElementIndex !== -1) {
        let uiStyleString = elements[uiElementIndex].value;
        if (isAppend) {
          uiStyleString = uiStyleString.slice(
            0,
            uiStyleString.indexOf('</style>')
          );

          uiStyleString += `${uiCssString}\n</style>`;
        } else {
          uiStyleString = `<style>\n${uiCssString}\n</style>`;
        }
        elements[uiElementIndex].value = uiStyleString;
      } else {
        const styleElement = {
          id: Math.round(Math.random() * 100000 + new Date().getTime()),

          options: [],
          structure: { tab: 0, row: 0, col: 0 },
          attributes: { required: true, disabled: false },
          name: 'automatedaicss',
          label: 'Automated AI CSS',
          placeholder: 'automatedaicss',
          type: 'automatedaicss',
          value: '',
          settings: {
            default: false,
            highlight: false,
            layoutItem: true,
          },
        };

        styleElement.value = `<style>\n${uiCssString}\n</style>`;
        elements.push(styleElement);
      }
    },
    addSelectedDatabase(database) {
      if (!this.isTableIdArray) {
        if (this.process.tableID != '') {
          this.process.tableID = [this.process.tableID, database];
        } else this.process.tableID = [database];
      }
      if (this.isTableIdArray) {
        this.process.tableID.push(database);
      }
    },
    removeAiCss() {
      const aiElemIndex = this.elements.findIndex(
        (element) => element.type === 'automatedaicss'
      );
      if (this.isVueBasedFormBuilder) {
        this.task.props.elements.splice(aiElemIndex, 1);
      } else {
        this.task.props.formTrigger.elements.splice(aiElemIndex, 1);
      }
      document.querySelector('#automatedaicss')?.remove();
    },
    toggleAiDropdown(id) {
      if (this.aiDropdownId.includes(id)) {
        const index = this.aiDropdownId.indexOf(id);
        this.aiDropdownId.splice(index, 1);
      } else {
        this.aiDropdownId.push(id);
      }
    },
    toggleDatabaseSchemaModal(toggle = false) {
      if (!this.isUserHasAccess) return;
      this.copyDatabaseSchemaIntoWorkflow.showDatabaseSchemaModal = toggle;
    },
    addSchemaIntoWorkflow(schema) {
      const removeElements = [
        'databaselinkedview',
        'freecontent',
        'timestampms',
      ];
      const elementsNames = this.elements.map((element) => element.name);
      const elementsLables = this.elements.map((element) => element.label);

      const elements = [];
      for (const element of schema) {
        if (removeElements.includes(element.type)) {
          continue;
        }
        if (element.type === 'filenew') {
          element.name = 'file';
          element.type = 'file';
          element.value = '';
          element.label = 'File';
        }
        if (elementsNames.includes(element.name)) {
          const nameTailingNumbers = element.name.match(/\d+$/)
            ? parseInt(element.name.match(/\d+$/)[0])
            : 1;
          const labelTailingNumbers = element.label.match(/\d+$/)
            ? parseInt(element.label.match(/\d+$/)[0])
            : 1;
          element.name = this.createUniqueName(
            [...elementsNames, ...elements.map((element) => element.name)],
            element.name,
            nameTailingNumbers + 1
          );
          element.label = this.createUniqueName(
            [...elementsLables, ...elements.map((element) => element.label)],
            element.label,
            labelTailingNumbers + 1
          );
        }
        elements.push(element);
      }
      if (this.isVueBasedFormBuilder) {
        this.task.props.elements.push(...elements);
      } else {
        this.task.props.formTrigger.elements.push(...elements);
      }
    },
    createUniqueName(names, name, num) {
      if (!names.includes(name)) {
        return name;
      } else {
        if (names.includes(name)) {
          name = name.replace(/[0-9]*$/, '');
          name += num;
        }
        return this.createUniqueName(names, name, ++num);
      }
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    async showFormPreview() {
      try {
        this.isPreviewLoading = true;
        const response = await this.generateHtml(true);
        const blob = new Blob([response.data], {
          type: response.headers['content-type'],
        });
        this.formPreviewBlobURL = URL.createObjectURL(blob);
      } catch (error) {
        this.isPreviewLoading = false;
        this.$emit('showToaster', 'Vorschau nicht möglich', 'Fehler', 'danger');
      }
    },
    onPreviewLoad() {
      this.isPreviewLoading = false;
    },
    toggleFormPreview(isVisible = false) {
      if (!this.isVueBasedFormBuilder) {
        if (isVisible) {
          this.showFormPreview();
        } else {
          this.revokePageURL();
        }
      }
      this.isFormPreview = isVisible;
    },
    revokePageURL() {
      if (this.formPreviewBlobURL) {
        URL.revokeObjectURL(this.formPreviewBlobURL);
        this.formPreviewBlobURL = null;
      }
    },

    onChangeCustomSpacingScreen(screen) {
      this.currentScreen = screen;
    },

    toggleAskAiLogicModal(isVisible = false) {
      this.isAskAiModalVisible = isVisible;
    },

    removeCurrentAIHover() {
      if (this.aiModalHoverElId) {
        const prevHoverEl = document.getElementById(this.aiModalHoverElId);
        prevHoverEl?.classList?.remove('active-ai-hover');
        this.aiModalHoverElId = null;
        this.hideAIHoverElLabel();
      }
    },
    handleFormMouseLeave() {
      this.removeCurrentAIHover();
    },
    handleFormHover(e) {
      const targetEl = e.target;
      this.removeCurrentAIHover();
      if (this.isAskAiLoading) return;

      let hoverId = targetEl.id;

      // if no id and this is a card-body, use parent id
      if (!hoverId && targetEl.classList?.contains('card-body')) {
        hoverId = targetEl.parentElement?.id;
      }

      if (!hoverId) return;

      this.aiModalHoverElId = hoverId;
      const hoverEl = document.getElementById(hoverId);
      hoverEl?.classList?.add('active-ai-hover');
      this.showAIHoverElLabel(hoverEl);
    },
    showAIHoverElLabel(hoverEl) {
      const hoverLabelEl = this.$refs.aiHoverLabelRef;
      if (!hoverLabelEl || !hoverEl) return;
      hoverLabelEl.textContent = hoverEl?.id;
      const rect = hoverEl.getBoundingClientRect();
      hoverLabelEl.style.top = `${rect.top - 26}px`;
      hoverLabelEl.style.left = `${rect.left}px`;
      hoverLabelEl.style.display = 'block';
    },
    hideAIHoverElLabel() {
      const hoverLabelEl = this.$refs.aiHoverLabelRef;
      if (hoverLabelEl) hoverLabelEl.style.display = 'none';
    },
    handleFormElementsClick(e) {
      if (this.isAskAiLoading) return;
      if (e.target.id) {
        this.selectedElementId = e.target?.id;
      } else if (
        !e.target.id &&
        e.target?.classList?.contains('card-body') &&
        e?.target?.parentNode?.classList?.contains('card-option-box')
      ) {
        this.selectedElementId = e.target?.parentNode?.id;
      }
    },
    onCloseFloatingDropdown() {
      this.selectedElementId = null;
      this.removeCurrentAIHover();
    },
    async loadPromptSuggetions() {
      try {
        const promptSuggestionResponse = await getFormPromptSuggestions(
          this.task,
          this.flowRunnerEndpoint
        );
        this.$store.dispatch('AddFormPromptSuggestions', {
          processId: String(this.process.id),
          taskId: String(this.task.id),
          suggestions: JSON.parse(promptSuggestionResponse),
        });
      } catch (error) {
        console.log('error while loading prompt suggetions', error);
      }
    },

    toggleAskAiLoading(isLoading = false) {
      this.isAskAiLoading = isLoading;
    },
    toggleFormFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    },
    isTabEmpty() {
      const tabs = this.task?.props?.structure?.tabs;

      let hasEmptyTab = false;

      if (tabs?.length > 0) {
        for (const tab of tabs) {
          let isTabEmpty = true;

          for (const row of tab?.rows) {
            if (row?.cols && row?.cols?.length > 0) {
              isTabEmpty = false;
              break; // No need to check further rows in this tab
            }
          }

          if (isTabEmpty) {
            hasEmptyTab = true;
            break; // No need to check further tabs
          }
        }
      }

      return hasEmptyTab;
    },
    toggleImportFormModal(value) {
      this.isImportFormModalVisible =
        typeof value === 'boolean' ? value : !this.isImportFormModalVisible;
    },
    onSchemaExport() {
      exportFormSchema({
        flowVersion: this.process?.version,
        task: this.task,
        workflowName: this.process?.name,
      });
    },
    onFileImport(jsonFile) {
      try {
        if (
          jsonFile &&
          typeof jsonFile === 'object' &&
          jsonFile !== null &&
          !Array.isArray(jsonFile)
        ) {
          if (!jsonFile?.version || Number(jsonFile.version) < 3) {
            this.showToaster('Ungültiges JSON-Format', 'Fehler!', 'danger');
            return;
          }
          this.pendingImportFile = jsonFile;
          this.isImportConfirmModalVisible = true;
        } else {
          this.showToaster('Ungültiges JSON-Format', 'Fehler!', 'danger');
        }
      } catch (e) {
        console.log('error :>> ', e);
      } finally {
        this.toggleImportFormModal(false);
      }
    },
    closeImportConfirmModal() {
      this.isImportConfirmModalVisible = false;
      this.pendingImportFile = null;
    },
    confirmImportReplace() {
      if (!this.pendingImportFile) return;
      this.applyImportedForm(this.pendingImportFile, 'replace');
      this.closeImportConfirmModal();
    },
    confirmImportMerge() {
      if (!this.pendingImportFile) return;
      this.applyImportedForm(this.pendingImportFile, 'merge');
      this.closeImportConfirmModal();
    },
    applyImportedForm(jsonFile, mode) {
      const importedProps = jsonFile?.props || {};
      const importedElements = importedProps?.elements || [];
      const importedStructure = importedProps?.structure || {};
      const importedSettings = importedProps?.settings || null;

      if (!Array.isArray(importedElements)) {
        this.showToaster('Ungültiges JSON-Format', 'Fehler!', 'danger');
        return;
      }

      const shouldReplace = mode === 'replace';
      const targetProps = this.isVueBasedFormBuilder
        ? this.task.props
        : this.task.props.formTrigger;

      const applyImportedSettings = () => {
        if (!importedSettings || typeof importedSettings !== 'object') return;

        const clonedSettings = JSON.parse(JSON.stringify(importedSettings));
        if (shouldReplace) {
          this.$set(targetProps, 'settings', clonedSettings);
          return;
        }

        const existingSettings =
          targetProps.settings && typeof targetProps.settings === 'object'
            ? targetProps.settings
            : {};
        const { aiGenerated: incomingAiGenerated, ...otherIncomingSettings } =
          clonedSettings;

        this.$set(targetProps, 'settings', {
          ...existingSettings,
          ...otherIncomingSettings,
        });

        if (
          Array.isArray(incomingAiGenerated) &&
          incomingAiGenerated.length > 0
        ) {
          const existingAiGenerated = Array.isArray(
            existingSettings.aiGenerated
          )
            ? existingSettings.aiGenerated
            : [];
          targetProps.settings.aiGenerated = [
            ...existingAiGenerated,
            ...incomingAiGenerated,
          ];
        }
      };

      if (shouldReplace) {
        this.$set(
          targetProps,
          'elements',
          JSON.parse(JSON.stringify(importedElements))
        );
        this.$set(
          targetProps,
          'structure',
          JSON.parse(JSON.stringify(importedStructure))
        );
        applyImportedSettings();
        this.formBuilderRenderKey += 1;
        return;
      }

      const existingElements = getFormElements(
        this.task,
        this.isVueBasedFormBuilder
      );
      const existingIds = new Set(
        existingElements.map((element) => element.id)
      );
      const existingNames = new Set(
        existingElements.map((element) => element.name)
      );
      const idMap = new Map();

      const createUniqueId = () => {
        let id = getUniqueID();
        while (existingIds.has(id)) id += 1;
        existingIds.add(id);
        return id;
      };

      const createUniqueName = (baseName, id) => {
        const safeBaseName = String(baseName || 'field').replace(/\s+/g, '');
        let name = safeBaseName;
        if (!existingNames.has(name)) {
          existingNames.add(name);
          return name;
        }
        name = `${safeBaseName}${id}`;
        let counter = 1;
        while (existingNames.has(name)) {
          name = `${safeBaseName}${id}_${counter}`;
          counter += 1;
        }
        existingNames.add(name);
        return name;
      };

      const importedTabs = importedStructure?.tabs || [];
      const baseStructure = getFormStructure(
        this.task,
        this.isVueBasedFormBuilder
      ) || { tabs: [] };
      const baseTabs = Array.isArray(baseStructure.tabs)
        ? baseStructure.tabs
        : [];

      const tabOffset = baseTabs.length;
      const hasMultipleImportedTabs = importedTabs.length > 1;
      const targetTabIndex = this.activeTab || 0;

      const clonedElements = importedElements.map((element) => {
        const newId = createUniqueId();
        idMap.set(element.id, newId);
        const newElement = JSON.parse(JSON.stringify(element));
        newElement.id = newId;
        newElement.name = createUniqueName(element.name, newId);
        return newElement;
      });

      if (hasMultipleImportedTabs) {
        clonedElements.forEach((element) => {
          if (!element.structure) element.structure = {};
          const oldTab = element.structure.tab || 0;
          element.structure.tab = tabOffset + oldTab;
        });

        const mappedTabs = importedTabs.map((tab) => {
          const mappedTab = JSON.parse(JSON.stringify(tab));
          (mappedTab.rows || []).forEach((row) => {
            (row.cols || []).forEach((col) => {
              if (col.elementId && idMap.has(col.elementId)) {
                col.elementId = idMap.get(col.elementId);
              }
              if (Array.isArray(col.childs)) {
                col.childs.forEach((child) => {
                  if (child.elementId && idMap.has(child.elementId)) {
                    child.elementId = idMap.get(child.elementId);
                  }
                });
              }
            });
          });
          return mappedTab;
        });

        baseTabs.push(...mappedTabs);
        baseStructure.tabs = baseTabs;
        targetProps.structure = baseStructure;
      } else {
        const targetTab = baseTabs[targetTabIndex];
        if (!targetTab) {
          baseTabs[targetTabIndex] = { label: 'Tab', rows: [] };
        }
        const rows = baseTabs[targetTabIndex].rows || [];
        const startingRowIndex = rows.length;

        clonedElements.forEach((element, idx) => {
          element.structure = {
            tab: targetTabIndex,
            row: startingRowIndex + idx,
            col: 0,
          };
          rows.push({ cols: [{ elementId: element.id }] });
        });

        baseTabs[targetTabIndex].rows = rows;
        baseStructure.tabs = baseTabs;
        targetProps.structure = baseStructure;
      }

      if (!Array.isArray(targetProps.elements)) targetProps.elements = [];
      targetProps.elements.push(...clonedElements);
      applyImportedSettings();
    },
  },

  watch: {
    task: {
      deep: true,
      handler: function (value) {
        const elements = getFormElements(value, this.isVueBasedFormBuilder);

        if (elements.find((el) => el.name === 'automatedaicss')) {
          const aiUiStyleElement = JSON.parse(
            JSON.stringify(elements.find((el) => el.name === 'automatedaicss'))
          );

          let styleElement = document.getElementById('automatedaicss');
          if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = 'automatedaicss';
            document.head.appendChild(styleElement);
          }
          if (aiUiStyleElement.value) {
            aiUiStyleElement.value = aiUiStyleElement.value.replace(
              '<style>',
              ''
            );
            aiUiStyleElement.value = aiUiStyleElement.value.replace(
              '</style>',
              ''
            );
            styleElement.innerHTML = aiUiStyleElement.value;
          }
        }
      },
    },
  },
  created() {
    // Add class to make background fixed
    document.body.classList.add('modal-open');

    if (this.showDatabaseMissing) {
      this.$set(this.process, 'tableID', this.isTableIdArray ? [] : '');
      this.isFlowReferenceModalVisible = true;
    }
    if (this.isVueBasedFormBuilder) this.loadPromptSuggetions();
  },
  beforeDestroy() {
    this.revokePageURL();
  },
  destroyed() {
    // remove class that makes background fixed
    document.body.classList.remove('modal-open');
  },
  computed: {
    ...mapGetters({
      databaseList: 'getDatabaseList',
      isAdmin: 'getIsAdmin',
    }),
    getFormBuilderURl() {
      if (
        this.settings &&
        this.settings.formBuilder &&
        this.settings.formBuilder !== null &&
        this.settings.formBuilder.trim() !== ''
      ) {
        return this.settings.formBuilder;
      } else {
        return 'v5';
      }
    },
    getformulaVersion() {
      const version = String(this.getFormBuilderURl || '').trim();
      const match = /^v(\d+)$/.exec(version);
      if (match) {
        return Number(match[1]);
      }
      return 6;
    },
    existingNames() {
      const elements = getFormElements(this.task, this.isVueBasedFormBuilder);
      let names = elements.map((e) => e.name);
      names.push(this.settings.reference.label);
      return names;
    },
    user() {
      return this.$store.state.user;
    },
    paramString() {
      let paramString = '';
      const elements = getFormElements(this.task, this.isVueBasedFormBuilder);

      elements.forEach((e) => {
        if (e.type != 'html') paramString += e.name + '=' + e.value + '&';
      });
      return paramString.slice(0, -1);
    },
    selectableTypes() {
      if (this.isAdmin)
        return this.typeList.filter((e) => e.visibility != 'hidden');
      return this.typeList.filter(
        (e) => e.visibility != 'hidden' && e.visibility != 'admin'
      );
    },
    activeTab() {
      return 0;
    },
    structure() {
      return getFormStructure(this.task, this.isVueBasedFormBuilder);
    },
    elements() {
      return getFormElements(this.task, this.isVueBasedFormBuilder);
    },
    isLoadProfileOrTimeseries: function () {
      const databaseType = this.isVueBasedFormBuilder
        ? this.process.settings?.databaseType
        : this.process.dataType;
      return databaseType === 'timeseries' || databaseType === 'loadprofile';
    },
    getSelectedDbList() {
      let selectedDbArr = [];
      if (!this.isTableIdArray) {
        selectedDbArr.push(this.process.tableID);
      }

      if (this.isTableIdArray) {
        selectedDbArr = this.process.tableID;
      }

      const dbList = this.getCustomDatabases.filter((el) =>
        selectedDbArr.includes(el.name.trim())
      );

      return dbList;
    },
    getCustomDatabases() {
      const dType = this.process.dataType;
      if (dType == 'timeseries' || dType == 'loadprofile') {
        return this.databaseList.filter(
          (e) => e.type == this.process.dataType || e.type == 'loadprofile'
        );
      } else
        return this.databaseList.filter((e) => e.type == this.process.dataType);
    },
    getElementsToHide() {
      return ['linktodatabase', 'filenew', 'timestampms', 'smartmessage'];
    },
    isAiDropdownVisible() {
      return this.aiDropdownId.length !== 0;
    },
    getDropDownItems() {
      const flowVersion = this.process?.version ? this.process?.version : 2;
      const dropDownItems = [
        {
          label: 'API Code (cURL) kopieren',
          icon: 'fas fa-plug',
          clickTrigger: () => this.createCURL(),
        },
      ];
      if (flowVersion <= 2)
        dropDownItems.push({
          label: 'Einbetten',
          icon: 'fas fa-code',
          clickTrigger: () => this.copyEmbedScript(),
        });
      if (this.isAdmin && flowVersion <= 2)
        dropDownItems.push({
          label: 'HTML Herunterladen',
          icon: 'fas fa-download',
          clickTrigger: () => this.getFormAsHtmlFile(),
        });
      if (this.isAdmin && flowVersion >= 3)
        dropDownItems.push({
          label: 'Schema importieren',
          icon: 'fas fa-upload',
          clickTrigger: () => this.toggleImportFormModal(true),
        });
      if (this.isAdmin && flowVersion >= 3)
        dropDownItems.push({
          label: 'Schema runterladen',
          icon: 'fas fa-download',
          clickTrigger: () => this.onSchemaExport(),
        });
      return dropDownItems;
    },

    getFormMaxWidth() {
      if (!this.isVueBasedFormBuilder) return {};
      const screenMaxWidthMap = {
        mobile: '375px',
        tablet: '768px',
        laptop: '1440px',
        desktop: '100%',
      };

      return this.task.props?.settings?.layout?.spacing == 'custom'
        ? screenMaxWidthMap[this.currentScreen]
        : '100%';
    },

    getPreviewFormStyles() {
      if (this.task.props?.settings?.layout?.spacing != 'custom') return '';
      const breakpoints = getScreenBreakPoints();
      const className = '.form-item-wrapper';

      let css = '';
      const spacingConfig =
        this.task.props?.settings?.layout?.customSpacing || {};
      for (const screen of Object.keys(breakpoints)) {
        console.log('screen', screen);

        const padding = spacingConfig[screen] || {
          top: { value: 0, unit: 'px' },
          left: { value: 0, unit: 'px' },
          bottom: { value: 0, unit: 'px' },
          right: { value: 0, unit: 'px' },
        };
        const rules = [
          `padding-top: ${padding.top.value}${padding.top.unit} !important;`,
          `padding-left: ${padding.left.value}${padding.left.unit} !important;`,
          `padding-bottom: ${padding.bottom.value}${padding.bottom.unit} !important;`,
          `padding-right: ${padding.right.value}${padding.right.unit} !important;`,
        ].join('\n  ');

        if (breakpoints[screen]) {
          css += `@media (min-width: ${breakpoints[screen]}) {\n  ${className} {\n  ${rules}\n  }\n}\n\n`;
        } else {
          css += `${className} {\n  ${rules}\n}\n\n`;
        }
      }
      return css;
      // return '';
    },
    isVueBasedFormBuilder() {
      return getIsVueBasedFormBuilder(this.process);
    },
  },
  components: {
    flowReferenceModal,
    flowAuthModal,
    FormBuilder,
    FormBuilderV2,
    LoadingSpinner,
    askAiUiModal,
    GeneralDropdown,
    DatabaseSchemaSelect,
    PagePreviewModal,
    FormSettingModal,
    AskAImodal,
    ImportFormConfirmModal,
    JsonImportFormModal,
    FloatingAskAiDropdown: () =>
      import('@/components/FormBuilder/AskAI/FloatingAskAiDropdown.vue'),
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.start-task-wrapper .modal.task.fullscreen {
  width: 100% !important;
  height: 100% !important;
  border-radius: 0px !important;
}

.start-task-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.heading {
  padding: 15px 15px 0px;
  text-align: center;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
  height: 100%;
}

h1 {
  padding-top: 46px;
  padding-bottom: 8px;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  margin: 0 0 4px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}

h3 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 10px;
}

h4 {
  color: rgba(85, 93, 109, 0.4);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 0px;
}

.tab {
  text-align: left;
  background: #f9f9fb;
  padding-top: 0px;
}

.tab.tab-form {
  min-height: 450px;
  background-color: #fff;
  height: 100%;
}

.tab.tab-time {
  height: 350px;
}

input,
select {
  font-family: 'Open Sans', open-sans, sans-serif;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  margin-right: 10px;
  margin-bottom: 15px;
  height: 51px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 20px;
  font-weight: 300;
}

select {
  width: 70%;
}

.date {
  margin-top: 0;
  width: 53%;
}

.time {
  width: 33%;
}

textarea {
  resize: none;
  float: left;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  padding-bottom: 15px;
  margin-bottom: 0;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0px 0px 0px 10px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 134px;
  width: 95%;
  overflow: hidden;
}

button {
  border: 1px solid #dee3e9;
  border-radius: 3px 3px 3px 3px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 25px;
  cursor: pointer;
}

button.default {
  color: #464d5d;
  background: #fff;
}

.input-group {
  display: inline-block;
  width: 100%;
}

.imput-group > input {
  width: 40%;
  margin: 0px 20px 20px 0px;
}

.input-group > button {
  min-width: 0;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  background: #6bbc7c;
  border: 1px solid #5ab36c;
  margin-bottom: 0;
  border-radius: 0 3px 3px 0;
}

.pull-right {
  float: right;
  height: 50px;
  overflow: hidden;
  margin-right: 15px;
  margin-top: 15px;
}
.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

ul.tabsLabels {
  display: inline-block;
  padding: 0;
  margin: 0 0 -1px;
}

.modal ul.tabsLabels li {
  display: inline-block;
  margin-right: 44px;
  list-style: none;
  padding: 0;
  line-height: 14px;
}

.modal:not(.custom) li {
  font-size: 14px;
  line-height: 25px;
  color: #7e8890;
}

.modal ul.tabsLabels a {
  color: #a4abb1;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  padding: 21px 7px 22px 33px;
  border-bottom: 2px solid transparent;
  display: block;
  position: relative;
}

.modal ul.tabsLabels a.datetime {
  padding: 21px 7px 22px 0px;
}

a {
  text-decoration: none;
  -webkit-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  -o-transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  transition: color 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease;
  cursor: pointer;
}

a {
  background-color: transparent;
}

.modal ul.tabsLabels a.active {
  border-color: #52b266;
}

.modal ul.tabsLabels a.active,
.modal ul.tabsLabels a:hover {
  color: #464d5d;
  text-decoration: none;
}

/*@media not all, not all, (-webkit-min-device-pixel-ratio: 1.5), not all, (min-resolution: 1.5dppx)*/

.tabsLabels .email {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -1100px -1110px;
}

.tabsLabels .form {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -893px -1110px;
}

.tabsLabels .alert {
  background-image: url('../../assets/img/modal-sprite.png');
  background-size: 1293px 1277px;
  background-position: -546px -1110px;
}

p {
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  color: #7e8890;
  margin: 25px 0px 25px 0px;
}

.systems {
  background-color: #f9f9fb;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  color: #5f697a;
  line-height: 17px;
  margin: 0;
  display: block;
  overflow: auto;
  width: 100%;
}

.item-wrapper {
  display: block;
  position: relative;
  float: left;
  width: 120px;
  border-radius: 4px;
  background: #fff;
  height: 150px;
  text-align: center;
  margin: 0 39px 43px 0;
  -webkit-box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  box-shadow: 0 1px 2px rgba(43, 59, 93, 0.29);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.item-wrapper h2 {
  color: #424956;
  font-size: 12px;
  font-weight: 400;
  line-height: inherit;
  margin-top: 0px;
}

.systems-wrapper {
  width: 100%;
  margin: 24px 31px;
}

.img-wrapper {
  width: 100%;
  height: 111px;
}

.systems .logo {
  position: absolute;
  width: 70%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.icon {
  width: 30px;
  float: left;
  margin-right: 10px;
  margin-top: 6px;
}

.icon svg {
  fill: #959ba8;
}

.btn-default {
  background-color: #fff;
  color: #959ba8;
  text-align: center;
  border-color: rgb(214, 214, 221);
  line-height: 50px;
  cursor: pointer;
}

.tab.tab-form button {
  width: fit-content;
  padding-right: 19px;
  float: right;
  margin: 0 0 0 5px;
}

.tab.tab-form button.btn-green {
  padding-left: 20px;
}

.params {
  float: left;
  width: 30%;
}

.params > h2 {
  padding-top: 0;
  padding-bottom: 15px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #797c81;
  font-weight: 400;
  line-height: 19px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 16px;
  text-transform: uppercase;
  text-align: left;
}

.modal.task .header {
  width: 100%;
}
.modal.task {
  padding: 60px 94px 40px 94px !important;
}

.modal.task .header .tools {
  float: right;
  height: 70px;
  width: auto;
  flex-direction: row;
  margin-top: 5px;
  z-index: 52;
}

.modal.task .header .tools .item {
  display: inline-block;
  text-align: center;
  line-height: 61px;
  margin-left: 10px;
}

.modal.task .form-group .tools {
  height: 100%;
  left: 2px;
  top: 0;
  cursor: pointer;
  display: inline;
  width: 3%;
  opacity: 0;
  -webkit-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
}

.modal.task .form-group:hover .tools {
  opacity: 1;
}

.form-container {
  background: #fff;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100% - 72px);
  display: flex;
  justify-content: center;
}

.start-task-wrapper .form-container .initial-form {
  height: 100%;
  width: 100%;
}
/* .start-task-wrapper .form-container .initial-form .start-form-builder {
  height: calc(100% - 100px);
} */

.start-task-wrapper
  .form-container
  .initial-form
  ::v-deep
  .start-form-builder
  .content.flow-items-modal-scroll {
  height: 100%;
}

.start-task-wrapper
  .form-container
  .initial-form
  ::v-deep
  .start-form-builder
  .content.flow-items-modal-scroll
  .tab.tab-form {
  height: 100%;
}

.start-task-wrapper
  .form-container
  .initial-form
  ::v-deep
  .add-element-wrapper {
  max-height: calc(100vh - 420px) !important;
}

.start-task-wrapper .form-container .initial-form ::v-deep {
}

.form-header {
  display: block;
  height: 100px;
}

.form-settings {
  float: right;
  padding-right: 25px;
}

.form-settings i {
  font-size: 30px;
  padding-left: 15px;
  cursor: pointer;
}

.form-container input.title {
  z-index: 4;
  text-align: center;
  display: block;
  padding-bottom: 8px;
  font-size: 33px;
  color: #464d5d;
  margin: 5px 5px 5px 7px;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  border: 0;
  height: 50px;
  float: left;
  width: 99%;
}

.form-container input.description {
  z-index: 4;
  text-align: center;
  border: 0;
  display: block;
  float: left;
  margin: 5px 5px 15px 7px;
  width: 99%;
  color: #888d9c;
}

.form-input {
  cursor: text;
}

.form-input.highlighted {
  background: #ff000024;
}

.form-container .tools {
  float: right;
  width: 32px;
  height: 30px;
  margin-top: -41px;
}
.form-container .tools i {
  font-size: 18px;
}
.form-container .edit-overlay {
  top: 0;
  width: 97%;
  height: 100%;
  -webkit-transition: opacity 450ms ease-in-out;
  transition: opacity 450ms ease-in-out;
  cursor: unset;
  background: rgb(222 225 231 / 88%);
  opacity: 0;
  position: absolute;
  display: block;
  left: 0;
  border-radius: 6px;
  cursor: pointer;
}

.form-container .edit-overlay.large {
  height: 105%;
}

.form-container .edit-overlay:hover {
  opacity: 0.5;
}

.form-container .drop-zone {
  border: 5px solid #86c3f4;
}

.form-container .drop-zone.horizontal {
  width: 100%;
  height: 5px;
}

.form-container .drop-zone.vertical {
  float: right;
  display: inline-block;
  position: relative;
}

.add-button-wrapper {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 250px;
}

.add-button {
  cursor: pointer;
  display: block;
  color: white;
  border-radius: 50%;
  background-color: #191f25;
  height: 60px;
  width: 60px;
  line-height: 55px;
  font-size: 32px;
  font-weight: 100;
  -webkit-box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  box-shadow: 0.5px 0.87px 5px 0 rgb(0 0 0 / 28%);
  -webkit-transition: -webkit-transform 0.2s ease-in-out;
  transition: -webkit-transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out;
  transition: transform 0.2s ease-in-out, -webkit-transform 0.2s ease-in-out;
  background-size: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.add-button:hover {
  transform: scale(1.1);
}

[disabled] {
  opacity: 0.5;
  cursor: not-allowed !important;
}
.modal.task .header .tools .item:hover:not([disabled]) {
  transform: scale(1.1) rotate(0);
}

.input-group > button {
  min-width: 0;
  width: 99px;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  background: #fff;
  margin-bottom: 0;
  margin-left: 0;
  border-radius: 0 3px 3px 0;
  margin-top: 0;
  font-size: 35px;
  font-weight: 200;
}

.input-group > select {
  margin-right: 0;
  border-radius: 0 3px 3px 0;
}

button {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
  width: 30%;
  height: 51px;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 17px;
  margin-bottom: 20px;
  margin-right: 30px;
}

.form-container form.codelos-app {
  width: 800px;
  text-align: left;
  min-height: 200px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.form-container form.codelos-app.full-width {
  width: 100%;
}

.form-container label {
  width: 80%;
  font-family: 'Open Sans', open-sans, sans-serif;
  display: block;
  padding-top: 0;
  padding-bottom: 6px;
  margin-right: 10px;
  margin-bottom: 0px;
  color: #464d5d;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-weight: 300;
  padding-left: 12px;
}

.form-container input,
.form-container select {
  border-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  padding-left: 12px;
  width: 95%;
  padding-bottom: 15px;
  margin-bottom: 0;
  height: 35px;
  padding-bottom: 14px;
  padding-top: 15px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 12px 11px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

form .form-group {
  width: 100%;
  height: 80px;
  margin-top: 0px;
  padding-top: 20px;
  padding-bottom: 1px;
  position: relative;
}

.form-group.large {
  height: 160px;
}

.radio-wrapper {
  width: 100%;
  display: block;
}

.radioOption {
  display: inline-block;
  width: fit-content;
  height: 40px;
  margin-right: 22px;
}

.radioOption input {
  float: none;
  width: 20px;
}

.radioOption label {
  line-height: 31px;
  float: right;
  padding: 0;
  margin-bottom: 0.3em;
  margin-right: 0;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: 12px;
  height: 31px;
}

.round-button {
  cursor: pointer;
  display: block;
  color: #1d1d1f;
  border-radius: 50%;
  background-color: white;
  height: 60px;
  width: 60px;
  text-align: center;
  line-height: 60px;
  font-weight: 100;
  box-shadow: 0.5px 0.87px 5px 0 rgba(0, 0, 0, 0.28);
  transition: transform 0.2s ease-in-out;
  font-size: 17px;
}

.footer {
  position: fixed;
  bottom: 21px;
}
.message {
  position: absolute;
  color: #54c08a;
  font-size: 16px;
  margin: 0;
  margin-top: 3px;
}

.loading-spinner {
  width: 100%;
  height: 100%;
  background-color: #ffff;
}

.loading-spinner.transparent {
  background-color: #9191912e;
}

.file-key-selector {
  position: absolute;
  top: 25%;
  left: 40%;
  background: white;
  z-index: 10;
  width: 200px;
  height: 300px;
}

@keyframes progress-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.drop-down {
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
  padding: 11px;
  border-radius: 9px;
  box-shadow: 0 2px 8px rgb(31 37 50 / 18%);
  bottom: 10px;
  position: relative;
  z-index: 100;
  width: 238px;
  list-style: none;
  background-color: #fff;
  overflow: scroll;
  height: 450px;
  border: none;
  top: -280px;
  margin-left: -271px;
}

.drop-down.add-element img {
  background-color: #fefbfb;
  vertical-align: middle;
  border-style: none;
  width: 50px;
  padding: 13px;
  margin: 4px;
  border-radius: 5px;
  border: 1px solid #d2d0d0;
}

.drop-down.add-element .item {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
}

.drop-down.add-element .item:hover {
  background-color: #f1efef;
}

.col {
  max-width: 89%;
}
.workflow-model-scroll .modal.task,
.workflow-model-scroll .modal.task .form-container {
  overflow-y: hidden;
}
.start-task-wrapper .form-container .initial-form ::v-deep .form-tab {
  max-height: calc(100dvh - 520px);
  overflow-y: auto;
  overflow-x: hidden;
}
.start-task-wrapper ::v-deep .filter-dropdown .customDropdown {
  width: 89px;
}
.start-task-wrapper .extra-options-wrapper {
  display: flex;
  justify-items: center;
  align-items: center;
  gap: 10px;
}
.start-task-wrapper .round-button.options ::v-deep .dropdown {
  border-radius: 0.375rem;
  border-radius: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100% !important;
  height: 100% !important;
}

.start-task-wrapper .round-button.options ::v-deep .dropdown-toggle {
  width: 100% !important;
  height: 100% !important;
}
.start-task-wrapper .round-button.options ::v-deep .line-clamp {
  margin: 0 auto;
}
.start-task-wrapper .round-button.options:hover {
  transform: none !important;
}
.start-task-wrapper .daten-bank-schema img {
  width: 19px;
  height: 19px;
}

.start-task-wrapper .preview .full-screen img {
  width: 20px;
  height: 20px;
}
.start-task-wrapper .modal-header-actions {
  position: absolute;
  top: 32px;
  right: 36px;
  z-index: 54;
  display: flex;
  align-items: center;
  gap: 10px;
}
.start-task-wrapper .fullscreen-icon {
  position: static;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  line-height: 16px;
  color: #000;
  cursor: pointer;
}
.start-task-wrapper .fullscreen-icon.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.start-task-wrapper .modal-header-actions .modal-close {
  position: static !important;
}

.start-task-wrapper .preview img {
  width: 27px;
  height: 27px;
}
.start-task-wrapper .preview ::v-deep a {
  text-indent: unset !important;
}
.start-task-wrapper .preview[disabled] a {
  pointer-events: none;
}
.start-task-wrapper .preview-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: #ffffff;
  z-index: 53;
}

.start-task-wrapper .preview-wrapper .hide {
  visibility: hidden;
}

.start-task-wrapper .loading-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 11;
}
.start-task-wrapper .form-builder-wrapper {
  position: unset;
  height: 100%;
  width: 100%;
}
::v-deep .active-ai-hover {
  outline: 2.2px solid #ff0000 !important;
  outline-offset: -2.2px;
  cursor: url('../../assets/img/work-flow-icons/magic-stick.svg') 16 16, auto !important;
}
.start-task-wrapper .ai-hover-label {
  position: fixed;
  background: #ff0000;
  color: #ffffff;
  font-size: 12px;
  padding: 4px;
  border-radius: 2px;
  z-index: 999;
  pointer-events: none;
  display: none;
}

.start-task-wrapper .magic-comment img {
  margin-bottom: 6px;
  margin-left: 3px;
}
.start-task-wrapper .save-workflow {
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
}
.start-task-wrapper .save-workflow img {
  width: 17px;
  height: 17px;
}
.start-task-wrapper .save-workflow i {
  font-size: 17px;
}
.start-task-wrapper .save-workflow.disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>
